export default __webpack_public_path__ + "static/media/B204.ca2f8ecb.jpg";